import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "dropzone", "preview", "removeFlag", "image", "closeButton"];
  static values = { maxSize: { type: Number, default: 10 * 1024 * 1024 } };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly dropzoneTarget: HTMLElement;
  declare readonly previewTarget: HTMLElement;
  declare readonly removeFlagTarget: HTMLInputElement;
  declare readonly imageTarget: HTMLImageElement;
  declare readonly closeButtonTarget: HTMLButtonElement;
  declare readonly hasRemoveFlagTarget: boolean;
  declare readonly maxSizeValue: number;

  connect() {
    if (this.previewTarget.dataset.hasImage === "true") {
      this.showPreview();
    } else {
      this.hidePreview();
    }
  }

  openPicker() {
    this.inputTarget.click();
  }

  handleImageSelect(event: Event) {
    const image = (event.target as HTMLInputElement).files?.[0];
    if (image) this.processImage(image);
  }

  handleDragOver(event: DragEvent) {
    event.preventDefault();
    this.dropzoneTarget.classList.add("border-[#14126F]", "bg-gray-50");
  }

  handleDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("border-[#14126F]", "bg-gray-50");
  }

  handleDrop(event: DragEvent) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove("border-[#14126F]", "bg-gray-50");

    const image = event.dataTransfer?.files[0];
    if (!image) return;

    const dt = new DataTransfer();
    dt.items.add(image);
    this.inputTarget.files = dt.files;

    this.processImage(image);
  }

  removeImage() {
    this.inputTarget.value = "";
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "1";
    this.hidePreview();
  }

  private processImage(image: File) {
    this.updateImagePreview(image);
    this.showPreview();
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = "0";
  }

  private updateImagePreview(image: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        this.imageTarget.src = e.target.result as string;
        this.imageTarget.classList.remove("hidden");
      }
    };
    reader.readAsDataURL(image);
  }

  private showPreview() {
    this.dropzoneTarget.classList.add("hidden");
    this.previewTarget.classList.remove("hidden");
    this.imageTarget.classList.remove("hidden");
    this.closeButtonTarget.classList.remove("hidden");
  }

  private hidePreview() {
    this.dropzoneTarget.classList.remove("hidden");
    this.previewTarget.classList.add("hidden");
    this.imageTarget.src = "";
    this.imageTarget.classList.add("hidden");
    this.closeButtonTarget.classList.add("hidden");
  }
}
